module.exports = __webpack_public_path__ + "static/media/LogoBusinessReportTransWhiteLong.b8d3da5e.png";